/**
 * SW 更新连接单例（浏览器接线，15b）。
 *
 * main.tsx 启动时调一次（注册 SW + 接更新事件），UpdateBanner 调同一个单例拿
 * apply/dismiss。判定与接线在 ./swUpdateState（可注入、可单测），这里只管单例。
 *
 * `swRegistration()` 把那一次注册的 Promise 也开放出来给 18c1 的推送订阅用——
 * 必须共用，`registerServiceWorker()` 本身不记忆，调两次就注册两次。
 */
import { globalStore } from './global';
import { browserSwUpdateDeps, connectSwUpdate, type SwUpdateConnection } from './swUpdateState';
import { registerServiceWorker } from '~/sw/register';

let conn: SwUpdateConnection | undefined;
let registration: Promise<ServiceWorkerRegistration | null> | undefined;

/** 本页唯一的一次 SW 注册（恒 resolve；dev/不支持/失败 = null） */
export function swRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (!registration) registration = registerServiceWorker();
  return registration;
}

export function swUpdate(): SwUpdateConnection {
  if (!conn) {
    conn = connectSwUpdate(globalStore(), browserSwUpdateDeps(swRegistration()));
  }
  return conn;
}
